import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'
import { usersQueryKeys } from 'utils/query-keys'

const reactivatePhoneNumber = async (phoneNumberId: string) => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v2/phone_numbers/${phoneNumberId}/reactivate`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
    }
  )
  const handledResponse = handleErrors(response)
  return handledResponse.json()
}

const useReactivatePhoneNumber = () => {
  const queryClient = useQueryClient()
  return useMutation(reactivatePhoneNumber, {
    onSuccess: () => {
      toast('Phone number successfully reactivated', { icon: '📞' })
    },
    onError: (error: Error) => {
      console.error('Error reactivating phone number:', error)
      toast('Failed to reactivate phone number. Please try again.')
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(usersQueryKeys as any)
    },
  })
}

export default useReactivatePhoneNumber
